import { FeatureFlagNames } from 'common/open-features'
import { useCheckFlag } from 'common/open-features/hooks'
import { CorporateIncomeTaxDetailContainer } from 'containers/accounting/corporate-income-tax-detail'

import OldPage from '../corporate-income-tax-report'

const CorporateIncomeTaxDetailPage = () => {
  const { isEnable } = useCheckFlag(FeatureFlagNames.RefactorPagePhase13)

  return isEnable ? <CorporateIncomeTaxDetailContainer /> : <OldPage />
}

export default CorporateIncomeTaxDetailPage
